import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Calendar } from 'lucide-react';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

const Spotlight = () => {
  const [spotlights, setSpotlights] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSpotlights();
  }, []);

  const fetchSpotlights = async () => {
    try {
      const response = await axios.get(`http://3.109.108.187/api/spotlight`);
      setSpotlights(response.data);
    } catch (error) {
      console.error('Error fetching spotlights:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="spotlight-page">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[300px] mt-20" data-testid="spotlight-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-green-600"></div>
        <div className="relative h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">Spotlight of the Week</h1>
            <p className="text-xl text-white/90">Celebrating achievements and milestones</p>
          </div>
        </div>
      </section>

      {/* Spotlight Grid */}
      <section className="section-spacing" data-testid="spotlight-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-20">
              <div className="inline-block w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="mt-4 text-gray-600">Loading spotlights...</p>
            </div>
          ) : spotlights.length > 0 ? (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {spotlights.map((spotlight, index) => (
                <div key={spotlight.id} className="bg-white rounded-2xl shadow-xl overflow-hidden hover-lift" data-testid={`spotlight-${index}`}>
                  <div className="h-72 relative">
                    <img
                      src={spotlight.image_url}
                      alt={spotlight.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 right-4">
                      <span className="px-4 py-2 bg-white/90 rounded-full text-sm font-bold text-orange-600 shadow-lg">
                        {spotlight.week}
                      </span>
                    </div>
                  </div>
                  <div className="p-8">
                    <h3 className="text-2xl font-bold text-gray-800 mb-4">{spotlight.title}</h3>
                    <p className="text-gray-600 leading-relaxed mb-4">{spotlight.description}</p>
                    <div className="flex items-center text-sm text-gray-500">
                      <Calendar size={16} className="mr-2" />
                      {new Date(spotlight.created_at).toLocaleDateString()}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="text-6xl mb-4">⭐</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">No Spotlights Yet</h3>
              <p className="text-gray-600">Check back soon for featured stories and achievements!</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Spotlight;